import api from "../services/api";

const PLAN_FLAGS = [
  "useCampaigns",
  "useKanban",
  "useSchedules",
  "useInternalChat",
  "useExternalApi",
];

const DEFAULTS = {
  useCampaigns: false,
  useKanban: true,
  useSchedules: false,
  useInternalChat: false,
  useExternalApi: false,
};

export const readCachedPlanFlag = (companyId, flag, defaultValue = false) => {
  if (!companyId) return defaultValue;
  try {
    const cached = localStorage.getItem(`plan_${companyId}_${flag}`);
    if (cached !== null) return cached === "true";
  } catch (err) {
    // ignore
  }
  return defaultValue;
};

export const cachePlanFlags = (companyId, plan) => {
  if (!companyId || !plan) return;

  PLAN_FLAGS.forEach((flag) => {
    try {
      localStorage.setItem(
        `plan_${companyId}_${flag}`,
        String(!!plan[flag])
      );
    } catch (err) {
      // ignore
    }
  });
};

export const applyCachedPlanFlags = (companyId) => ({
  showCampaigns: readCachedPlanFlag(
    companyId,
    "useCampaigns",
    DEFAULTS.useCampaigns
  ),
  showKanban: readCachedPlanFlag(companyId, "useKanban", DEFAULTS.useKanban),
  showSchedules: readCachedPlanFlag(
    companyId,
    "useSchedules",
    DEFAULTS.useSchedules
  ),
  showInternalChat: readCachedPlanFlag(
    companyId,
    "useInternalChat",
    DEFAULTS.useInternalChat
  ),
  showExternalApi: readCachedPlanFlag(
    companyId,
    "useExternalApi",
    DEFAULTS.useExternalApi
  ),
});

export const prefetchPlanFlags = async (companyId) => {
  if (!companyId) return null;

  try {
    const { data } = await api.get(`/companies/listPlan/${companyId}`);
    cachePlanFlags(companyId, data?.plan);
    return data?.plan ?? null;
  } catch (err) {
    console.log("Error prefetching plan config:", err);
    return null;
  }
};
